<!-- 召回通知单列表 -->
<template>
    <div>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                        <el-button type="primary" size="mini" @click="addDetail()">新增明细</el-button>
                                        <el-button type="primary" size="mini" @click="deleteDetails()" :disabled="sendDataInfo.woApplyDetails.length < 1">删除明细</el-button>
                                    </div>
                                    <!-- 明细信息 -->
                                    <el-table class="baseTable" v-if="mxForm" ref="mxTableRef" :data="sendDataInfo.woApplyDetails" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
                                        @selection-change="handleSelectionChange" border size="mini" :height="mxHeight">
                                        <el-table-column width="80" label="选择" v-if="dataActionBox.actionType != 2">
                                            <template slot-scope="scope">
                                                <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                                    <i class="el-icon-thumb"></i>
                                                </el-radio>
                                            </template>
                                        </el-table-column>
                                        <el-table-column type="index" width="50" label="序号"> </el-table-column>
                                        <template v-for="(formOneValue, formOneKey) in mxForm">
                                            <el-table-column v-if="formOneValue.isShow == 1" :key="formOneKey" :prop="formOneValue.entityField" :label="formOneValue.showField" :min-width="formOneValue.fieldWeight" show-overflow-tooltip>
                                                <template slot-scope="scope">
                                                    <!-- 显示通用名称 -->
                                                    <el-input :ref="formOneValue.entityField" v-if="formOneValue.entityField == 'bgmName'
														&& dataActionBox.actionType != 2 && formOneValue.isChange == 1" clearable
                                                        @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, '', formOneValue.focusField, formOneValue.nosetField, formOneValue.setField)"
                                                        v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                        <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, '', formOneValue.focusField, formOneValue.nosetField, formOneValue.setField)" slot="append"
                                                            icon="el-icon-search">
                                                        </el-button>
                                                    </el-input>
                                                    <span v-else>
                                                        {{scope.row[formOneValue.entityField]}}
                                                    </span>
                                                </template>
                                            </el-table-column>
                                        </template>
                                    </el-table>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
            </div>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
    name: "creditApplyAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                woApplyDetails: [],
            },
            detaislDataInfo: {},
            showTabs: "账簿信息",
            formDataList: [],
            DialogVisible: false,
            seTitle: "",
            seWidth: "",
            seId: "",
            seType: "",
            seIndex: "",
            sField: "", // 赋值字段
            fField: "", //焦点字段
            parentSearchData: {},
            mxHeight: 0,
            tabForm: [
                {
                    jciName: "账簿信息",
                    jurconfigform: []
                }
            ],
            mxForm: [],
            footForm: [],
            requesUrl: "",
            token: {
                token: sessionStorage.getItem("token"),
            },
            selectedDetailsIndex: 0,
            selectedRow: [], // 当前已选择行
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        //新增明细
        addDetail() {
            var flag = false;
            if (this.sendDataInfo.woApplyDetails.length > 0) {
                const hasEmptyBgmId = this.sendDataInfo.woApplyDetails.some(item => item.bgmId === "");
                if (hasEmptyBgmId) {
                    flag = true;
                    return this.$message({
                        message: "请不要重复新增空白行",
                        type: "warning",
                    });
                }
            }
            if (flag) {
                return;
            }
            // 直接创建包含默认值的对象，避免使用$set逐个设置
            const newDetailItem = { ...this.detaislDataInfo };
            // 如果有字段值为null或undefined，将其转换为空字符串
            for (const key in newDetailItem) {
                if (newDetailItem[key] == null) {
                    newDetailItem[key] = "";
                }
            }
            this.sendDataInfo.woApplyDetails.push(newDetailItem);
            // 使用变量缓存索引，避免重复计算
            const newIndex = this.sendDataInfo.woApplyDetails.length - 1;
            // 使用nextTick延迟DOM操作
            this.$nextTick(() => {
                this.selectedDetailsIndex = newIndex;
                this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                const refsElTable = this.$refs.mxTableRef;
                if (refsElTable) {
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                    );
                }
            });
        },
        // 表格切换焦点方法
        tableNextFocus(field, index) {
            this.seIndex = index;
            if (field == "keydown") {
                this.addDetail("sendDataInfo");
                return;
            } else if (field == "keydownnum") {
                if (this.sendDataInfo.woApplyDetails[index + 1] != undefined) {
                    this.$refs["woadPnumber"][index + 1].focus();
                    this.selectedDetailsIndexChange(index + 1);
                    return;
                } else {
                    this.addDetail("sendDataInfo");
                    return;
                }
            } else if (field == "keydownprice") {
                if (this.sendDataInfo.woApplyDetails[index + 1] != undefined) {
                    this.$refs["psprice"][index + 1].focus();
                    this.selectedDetailsIndexChange(index + 1);
                    return;
                } else {
                    this.addDetail("sendDataInfo");
                    return;
                }
            }
            this.$refs[field][index].focus();
        },
        imgur() {
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
        showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        changeInputModel(val) {
            this.DialogVisible = false;
            if (val && (val != "" || val != undefined)) {
                if (this.seType == 'bgmName') {
                    console.log(this.detaislDataInfo, val);

                    for (let key in this.detaislDataInfo) {
                        if (Object.prototype.hasOwnProperty.call(val, key)) {
                            console.log(val[key]);

                            this.$set(
                                this.sendDataInfo.woApplyDetails[this.seIndex],
                                key,
                                val[key] != null ? val[key] : ""
                            );
                        }
                    }
                    this.$nextTick(() => {
                        const refsElTable = this.$refs.mxTableRef;
                        if (refsElTable) {
                            refsElTable.clearSelection();
                            refsElTable.toggleRowSelection(
                                this.sendDataInfo.woApplyDetails[this.seIndex]
                            );
                        }
                    });
                }
            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField, fField) {
            this.parentSearchData = {}
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.fField = fField;
            this.parentSearchData[type] = this.sendDataInfo.woApplyDetails[index][type]
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },


        initActionBox(sendDataInfo) {
            this.$confirm("确定取消新增吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$emit("drawerCancel", 0);
                    this.init();
                    this.$refs.sendDataInfo.resetFields();
                })
                .catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '取消关闭'
                    // });
                });
        },
        init() {
            this.$set(this.sendDataInfo, "woApplyDetails", []);
        },

        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            var oldData = this.actionData.oldData;
            this.showTabs = this.actionData.formData[0].jciName;
            this.filterMainField();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                console.log(dataInfo,"测试");
                this.sendDataInfo.woApplyDetails.push(dataInfo);
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                this.sendDataInfo.woApplyDetails.push(dataInfo);
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight();
                    } else {
                        this.mxHeight = this.$common.getHeight();
                    }
                }, 16.7);
            });
        },
        sendDataAction(sendDataInfo) {
            if (this.sendDataInfo.woApplyDetails.length == 0) {
                return this.$message.error("请完善明细信息")
            }
            this.sub();
        },
        async sub() {
            let sendData = this.sendDataInfo.woApplyDetails.filter(item=>item.bgmId&&item.bgmName!="").map(item=>{
                return {
                    bgmId:item.bgmId,
                }
            })
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.prepaircontroladd(sendData);
            } else {
                var responseData = await this.$http.prepaircontrolupdate(sendData);
            }
            if (responseData.status == 200) {
                this.init();
                this.$message.success("操作成功");
                this.$emit("drawerCancel", 1);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (type == 'bgiType' || fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value == val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key == val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        // 过滤表单不同类型
        filterMainField() {
            this.mxForm = JSON.parse(JSON.stringify(this.formDataList));
            this.mxForm.forEach((item1) => {
                if (item1.fieldType == "number") {
                    this.$set(this.detaislDataInfo, item1.entityField, 0);
                } else if (item1.fieldType == "search" && item1.setField) {
                    var arr = item1.setField.split(",");
                    arr.forEach((item2) => {
                        this.$set(this.detaislDataInfo, item2, "");
                    });
                } else {
                    this.$set(this.detaislDataInfo, item1.entityField, "");
                }
            });
            this.$set(this.sendDataInfo, "woApplyDetails", []);
        },
        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = "",
                findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },

        // 选中行底色逻辑
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", {
                // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false,
            });
            let rowBackground = {};
            if (row.bgColor && row.bgColor != "")
                rowBackground.backgroundColor = row.bgColor;
            return rowBackground;
        },

        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef; // 获取表格对象
            let findRow = {};
            this.selectedDetailsIndex = row.rowIndex;
            findRow = this.selectedRow.find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },

        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.imgur();
        this.$nextTick(() => {
            this.openBox();

        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
    margin-bottom: 0;
}
</style>